import { Quaternion, Matrix4 } from 'three'

import { QuadFloatType } from './types'

export function quaternionToMatrix(rotationQuarternion: QuadFloatType) {
    const quaternion = new Quaternion().fromArray(rotationQuarternion)
    const rotationMatrix = new Matrix4().makeRotationFromQuaternion(quaternion)

    return rotationMatrix
}

export function matrixToQuaternionArray(rotationMatrix: Matrix4) {
    const rotationQuaternionArray = new Quaternion()
        .setFromRotationMatrix(rotationMatrix)
        .toArray()

    return rotationQuaternionArray
}
